
import React, { useEffect } from 'react';
import { EDSApplication } from '@ellucian/react-design-system/core';
import { IconSprite } from '@ellucian/ds-icons/lib';
import RouterPage from './pages/RouterPage';
import './App.css';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { Security } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';
import oktaConfig from './oktaConfig';
import TagManager from 'react-gtm-module';
import { appConfig } from './utils/config';
import { initializeConsentMode } from './utils/analytics';
import { ConsentBanner } from './components/ConsentBanner';



const oktaAuth = new OktaAuth(oktaConfig);
const restoreOriginalUri = async (oktaAuth: OktaAuth, originalUri: string) => {
  const postLoginRedirect = sessionStorage.getItem('postLoginRedirect');
  if (postLoginRedirect) {
    sessionStorage.removeItem('postLoginRedirect');
    window.location.replace(postLoginRedirect);
  } else {
    window.location.replace(originalUri || '/');
  }
};


const theme = createTheme({
  typography: {
  fontFamily: '"Proxima Nova", Montserrat, Aptos, Roboto, "Century Gothic", Futura, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
    h1: {
  fontFamily: 'Poppins, Montserrat, Aptos, Roboto, "Century Gothic", Futura, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    h2: {
  fontFamily: 'Poppins, Montserrat, Aptos, Roboto, "Century Gothic", Futura, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    h3: {
  fontFamily: 'Poppins, Montserrat, Aptos, Roboto, "Century Gothic", Futura, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    h4: {
  fontFamily: 'Poppins, Montserrat, Aptos, Roboto, "Century Gothic", Futura, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    h5: {
  fontFamily: 'Poppins, Montserrat, Aptos, Roboto, "Century Gothic", Futura, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    h6: {
  fontFamily: 'Poppins, Montserrat, Aptos, Roboto, "Century Gothic", Futura, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
    },
  },
  components: {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins, Montserrat, Aptos, Roboto, "Century Gothic", Futura, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
        },
      },
    },
  },
});


function App() {
  // Initialize GTM on app start
  useEffect(() => {
    if (appConfig.analytics.enabled) {
      // Initialize consent mode BEFORE GTM
      initializeConsentMode();
      
      // Initialize GTM
      TagManager.initialize({
        gtmId: appConfig.analytics.gtmContainerId,
        dataLayer: [{
          platform: 'Ellucian Marketplace',
          environment: process.env.NODE_ENV
        }]
      });
    } else {
      console.log('GTM disabled - no container ID provided');
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <EDSApplication>
        <IconSprite />
        <ConsentBanner />
         <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <RouterPage />
      </Security>
      </EDSApplication>
    </ThemeProvider>
  );
}

export default App;